export default "__VITE_ASSET__9e0c094f__"